module.exports = __webpack_public_path__ + "img/francoeur_5_cover.f64a37b9.jpg";